// seconds * minutes * hours * days
export const COOKIE_EXPIRATION_TIME = 60 * 60 * 24; // 1 day
export const TOKEN_COOKIE = 'bb.token';
export const REFRESH_TOKEN_COOKIE = 'bb.refreshToken';
export const BADGES_STORAGE_KEY = 'bb.badges';
export const MAD_PITSTOP_ENABLED = true;
export const VERSION = 'v4.0.125';

export const PRODUCTION_APIKEY = '632b56c1545dd07676621709';
export const IS_HOMOLOGATION = process.env.REACT_APP_APIKEY?.trim() !== PRODUCTION_APIKEY;

/** Marca que o usuário saiu pelo menu, para a tela de entrada diferenciar de sessão expirada. */
export const SAIDA_DELIBERADA = 'jj:saida-deliberada';
